import { trace } from 'rytm-helpers'
import Controller from './Controller'


class WatchembedController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initFrames()
  }
  

  /**
   * OWN
   */
  initFrames() {
    const container = document.querySelector(this.getContainerSelector())
    const list = container ? [...container.querySelectorAll("div[data-load-frame]")] : []
    list.forEach(this.loadFrame.bind(this))
  }
  loadFrame(el, index) {
    const url = el.dataset.loadFrame
    $.get(url, {}, (response) => {
      el.innerHTML = response
    })
  }

}

export default WatchembedController;